import {Injectable, Injector} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {EventModel} from '../models/event.model';
import {MatDialog, MatDialogConfig} from '@angular/material';
import {ErrorDialogComponent} from '../components/error-dialog/error-dialog.component';
import * as _ from 'lodash';
import {CookieService} from 'ngx-cookie-service';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {first} from 'rxjs/operators';
import {OrderModel} from '../models/order.model';

export let AppInjector: Injector;

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  private eventSource = new BehaviorSubject(new EventModel({type: null, data: null}));
  private order: any = {}; //Store customer selected information (when requesting order)
  private requestStep: string = 'fuel';
  private passwordPass: boolean = false; //If user already entered the right password in this session;
  private excludedDistributors: any = {}; //Excluded distributors from results
  private rescheduleOrder: OrderModel;
  private displayedDialogs: any = {reschedule: {}, rate: {}};

  eventObservable = this.eventSource.asObservable();
  rateLater: boolean = false;

  constructor(private dialog: MatDialog,
              private cookieService: CookieService,
              private http: HttpClient,
              private injector: Injector) {
    AppInjector = this.injector;

    let orderData = this.cookieService.get('w_order');
    if (orderData) this.order = JSON.parse(atob(orderData));

    let excluded = this.cookieService.get('w_exD');
    if (excluded) this.excludedDistributors = JSON.parse(atob(excluded));

    let rateLater = this.cookieService.get('w_rLate');
    if (rateLater) this.rateLater = true;
  }

  sendEvent(event: EventModel) {
    this.eventSource.next(event);
  };

  openErrorDialog(dialogData: Dialog, event?: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      title: dialogData.title,
      message: dialogData.body
    };
    let dialog = this.dialog.open(ErrorDialogComponent, dialogConfig);
    dialog.afterClosed()
      .toPromise()
      .then(_ => {
        this.sendEvent({type: event || 'error_closed'});
      });
  }

  getOrder() {
    if (!this.order) {
      let orderData = this.cookieService.get('w_order');
      if (orderData) this.order = JSON.parse(atob(orderData));
    }
    return this.order;
  }

  updateOrder(updates, step?: string) {
    if (step) this.requestStep = step;
    //Do updates on order
    this.order = _.merge(this.order, updates);
    //Store data in cookie for 2 hours (if user refresh the page)
    this.cookieService.set('w_order', btoa(JSON.stringify(this.order)), new Date(new Date().getTime() + 1000 * 60 * 60 * 2), '/');
  }

  setOrder(order, step?: string) {
    this.order = {};
    this.updateOrder(order, step);
  }

  getStep() {
    return this.requestStep;
  }

  addressSearch(search) {
    let params = _.merge(search, {key: environment.googleMapsKey.geocoding});
    return this.http.get('https://maps.googleapis.com/maps/api/geocode/json', {
      params: params
    })
      .pipe(first())
      .toPromise();
  }

  setPasswordPass(state: boolean) {
    this.passwordPass = state;
  }

  getPasswordPass() {
    return this.passwordPass;
  }

  getRateLater() {
    return this.rateLater;
  }

  setRateLater() {
    this.cookieService.set('w_rLate', 'later', new Date(new Date().getTime() + 1000 * 60 * 60 * 24), '/');
    this.rateLater = true;
  }

  //Store distributors that will be excluded from results
  addExcludedDistributor(distributorId: string) {
    let now = new Date().getTime();
    Object.getOwnPropertyNames(this.excludedDistributors)
      .map(key => {
        if (this.excludedDistributors[key] < now) delete this.excludedDistributors[key];
      });
    if (!this.excludedDistributors[distributorId]) {
      this.excludedDistributors[distributorId] = new Date().getTime() + 1000 * 60 * 60 * 24;
    }
    this.cookieService.set('w_exD', btoa(JSON.stringify(this.excludedDistributors)), new Date(new Date().getTime() + 1000 * 60 * 60 * 2), '/');
  }

  getExcludedDistributors() {
    return this.excludedDistributors;
  }

  addRescheduleOrder(order: OrderModel) {
    this.rescheduleOrder = order;
  }

  getRescheduleOrder() {
    return this.rescheduleOrder;
  }


}

export interface Dialog {
  title?: string,
  body: string,
  data?: any
}

